export default __webpack_public_path__ + "images/Dim-Sum.047f02.jpg";